<template>
  <div
    v-if="show"
  >
    <vue-content-loading
      v-if="$isResponsive"
      :width="mobileWidth"
      :height="mobileHeight"
      class="d-flex"
    >
      <rect
        v-for="({ x, y, rx, ry, innerWidth, innerHeight}, index) in mobileGrid"
        :key="index"
        :x="x"
        :y="y"
        :rx="rx"
        :ry="ry"
        :width="innerWidth"
        :height="innerHeight"
      />
    </vue-content-loading>
    <vue-content-loading
      v-else
      :width="width"
      :height="height"
    >
      <rect
        v-for="({ x, y, rx, ry, innerWidth, innerHeight}, index) in grid"
        :key="index"
        :x="x"
        :y="y"
        :rx="rx"
        :ry="ry"
        :width="innerWidth"
        :height="innerHeight"
      />
    </vue-content-loading>
  </div>
</template>

<script>
import VueContentLoading from 'vue-content-loading'

export default {
  name: 'ContentLoading',
  components: {
    VueContentLoading
  },
  props: {
    show: {
      type: Boolean,
      default: () => true
    },
    grid: {
      type: Array,
      default: () => [
        { x: 0, y: 0, rx: 0, ry: 0, innerWidth: 0, innerHeight: 0 }
      ]
    },
    width: {
      type: Number,
      default: () => 0
    },
    height: {
      type: Number,
      default: () => 0
    },
    mobileGrid: {
      type: Array,
      default: () => [
        { x: 0, y: 0, rx: 0, ry: 0, innerWidth: 0, innerHeight: 0 }
      ]
    },
    mobileWidth: {
      type: Number,
      default: () => 0
    },
    mobileHeight: {
      type: Number,
      default: () => 0
    }
  }
}
</script>
